export const isBase64Url = (image) => {
    return /^data:image\/[a-z]+;base64,/.test(image);
};